import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';

// Pages
import HomePage from './pages/HomePage';
import CitizenWizard from './pages/CitizenWizard';
import ConsultaTicket from './pages/ConsultaTicket';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminTickets from './pages/admin/AdminTickets';
import AdminTicketDetail from './pages/admin/AdminTicketDetail';
import AdminRutas from './pages/admin/AdminRutas';
import AdminRutaDetail from './pages/admin/AdminRutaDetail';
import AdminResumenDiario from './pages/admin/AdminResumenDiario';
import AdminVehiculos from './pages/admin/AdminVehiculos';
import AdminMapa from './pages/admin/AdminMapa';
import AdminHistorico from './pages/admin/AdminHistorico';

// Layout
import Layout from './components/Layout';
import AdminLayout from './components/AdminLayout';

// Protected Route
import { useAuthStore } from './lib/store';

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  return isAuthenticated ? children : <Navigate to="/admin/login" />;
};

function App() {
  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="solicitud" element={<CitizenWizard />} />
          <Route path="consulta" element={<ConsultaTicket />} />
        </Route>

        {/* Admin Routes */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<AdminDashboard />} />
          <Route path="tickets" element={<AdminTickets />} />
          <Route path="tickets/:id" element={<AdminTicketDetail />} />
          <Route path="rutas" element={<AdminRutas />} />
          <Route path="rutas/:id" element={<AdminRutaDetail />} />
          <Route path="resumen-diario" element={<AdminResumenDiario />} />
          <Route path="vehiculos" element={<AdminVehiculos />} />
          <Route path="mapa" element={<AdminMapa />} />
          <Route path="historico" element={<AdminHistorico />} />
        </Route>

        {/* 404 */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;
